module.exports = __webpack_public_path__ + "img/sqlCenter.21be5d6e.png";